import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header";
import Footer from "./Footer";
import Products from "./Products";
import HeadingNavbar from "./HeadingNavbar";  

export default function Product() {
  return (
    <div>
      <HeadingNavbar />
      <Header />
      <Products />
      <Footer />
    </div>
  );
}
